<svelte:options tag="cdlc-job-card-v2" />

<script>
  import debug from 'debug';
  import _ from 'lodash';
  import { createEventDispatcher } from 'svelte';
  import { get_current_component } from 'svelte/internal';
  import './JobCardV2Components/JobCardV2Actions/JobCardV2Actions.svelte';
  import './JobCardV2Components/JobCardV2Title/JobCardV2Title.svelte';
  import './JobCardV2Components/JobCardV2DetailList/JobCardV2DetailList.svelte';
  import './JobCardV2Components/JobCardV2Map/JobCardV2Map.svelte';
  const log = debug('cdlc:JobCardV2'),
    svelteDispatch = createEventDispatcher(),
    component = get_current_component(),
    dispatch = (name, detail) => {
      svelteDispatch(name, detail);
      component.dispatchEvent &&
        component.dispatchEvent(new CustomEvent(name, { detail }));
    };

  export let job_id = null;
  export let lead_id = null;
  export let show_recruiters = 'false';
  export let job = null;
  export let settings = {
    actionDropdownOptions: [],
    mainBottomBtns: [],
    shuffleJobData: true,
    showBenefits: true,
  };

  let api = "https://dedicatedjobs.cdllife.com";
  let loadedJob;
  let activeTab = 'list_view';
  let recruiterList = [];

  $: mergedSettings = _.merge(
    {
      mainBottomBtns: [
        { title: 'Edit Job', handler: 'edit', class: 'primaryBtn' },
        {
          title: `<svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.7565 0.75C13.9753 0.75 14.1667 0.941406 14.1667 1.16016L14.1393 5.61719C14.1393 5.83594 13.9753 6 13.7565 6H12.8542C12.6354 6 12.444 5.83594 12.444 5.61719L12.526 3.59375L12.4714 3.53906L4.84245 11.168C4.78777 11.2227 4.67839 11.2773 4.6237 11.2773C4.54167 11.2773 4.4323 11.2227 4.37761 11.168L3.7487 10.5391C3.69402 10.4844 3.63933 10.375 3.63933 10.293C3.63933 10.2383 3.69402 10.1289 3.7487 10.0742L11.3776 2.44531L11.3229 2.39062L9.29948 2.47266C9.08073 2.47266 8.91667 2.28125 8.91667 2.0625V1.16016C8.91667 0.941406 9.08073 0.777344 9.29948 0.777344L13.7565 0.75ZM11.9792 8.625C12.1979 8.625 12.4167 8.84375 12.4167 9.0625V13.4375C12.4167 14.1758 11.8151 14.75 11.1042 14.75H1.47917C0.740891 14.75 0.166672 14.1758 0.166672 13.4375V3.8125C0.166672 3.10156 0.740891 2.5 1.47917 2.5H5.85417C6.07292 2.5 6.29167 2.71875 6.29167 2.9375V3.375C6.29167 3.62109 6.07292 3.8125 5.85417 3.8125H1.64323C1.53386 3.8125 1.47917 3.89453 1.47917 3.97656V13.2734C1.47917 13.3828 1.53386 13.4375 1.64323 13.4375H10.9401C11.0221 13.4375 11.1042 13.3828 11.1042 13.2734V9.0625C11.1042 8.84375 11.2956 8.625 11.5417 8.625H11.9792Z"
              fill="#2E5FF6"
            />
          </svg>`,
          handler: 'landingPage',
          class: 'secondaryBtn',
        },
      ],
      shuffleJobData: true,
      showBenefits: true,
    },
    settings
  );
  $: shuffledJob = loadedJob && createdShuffledJob(loadedJob);
  $: text = _.get(shuffledJob, 'computedAds.text.0') || '';
  $: loadJob(job, job_id, lead_id)
    .then(job => {
      loadedJob = job;
    })
    .catch(e => {
      console.error('error loading job', e);
    });

  async function loadJob(job, job_id, lead_id) {

    if (job) {
      return job;
    } else if (job_id) {
      const params = new URLSearchParams({
        job: job_id,
        lead: lead_id || '',
      });

      const fetchData = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      const jobUrl = `${api}/api/jobs/jobCardDataV2?${params.toString()}`,
        res = await fetch(jobUrl, fetchData),
        json = await res.json(),
        job = json.data.job;


      if (lead_id) {
        _.set(job, '_leadData', json.data.leadData);
      }
      recruiterList = json.data.recruiterList;
      log('job', job);
      dispatch('loaded', job);
      return job;
    } else {
      return;
    }
  }

  function createdShuffledJob(job) {
    if (!job) return;
    if (typeof job !== 'object') return;
    if (job._shuffled) return job;

    if (settings.shuffleJobData) {
      job.computedAds = job.computedAds || {};
      job.computedAds.media = _.filter(
        _.shuffle(_.get(job, 'computedAds.media')),
        d => {
          return d.mediaType === 'IMAGE';
        }
      );
      job.computedAds.headlines = _.shuffle(job.computedAds.headlines);
      job.computedAds.text = _.shuffle(job.computedAds.text);
      job._shuffled = true;
      return job;
    } else {
      return job;
    }
  }
</script>

{#if loadedJob || shuffledJob}
  <div class="JobCardV2">
    <cdlc-job-card-v2-actions
      job={loadedJob || shuffledJob}
      settings={mergedSettings}
      {dispatch}
    />
    <cdlc-job-card-v2-title job={loadedJob || shuffledJob} {text} />

    <div class="JobCardV2-tabWrapper">
      {#if String(show_recruiters) === 'true'}
        <div class="JobCardV2-recruiterList-wrapper">
          {#if loadedJob.recruiters && recruiterList.length}
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.375 11.75C17.8242 11.75 19 10.5742 19 9.125C19 7.67578 17.8242 6.5 16.375 6.5C14.9258 6.5 13.75 7.67578 13.75 9.125C13.75 10.5742 14.9258 11.75 16.375 11.75ZM16.375 7.8125C17.0859 7.8125 17.6875 8.41406 17.6875 9.125C17.6875 9.86328 17.0859 10.4375 16.375 10.4375C15.6367 10.4375 15.0625 9.86328 15.0625 9.125C15.0625 8.41406 15.6367 7.8125 16.375 7.8125ZM10.6875 12.2969C10.3594 12.2969 10.0312 12.3516 9.70312 12.4609C9.32031 12.5703 8.91016 12.625 8.47266 12.625C8.0625 12.625 7.65234 12.5703 7.26953 12.4609C6.94141 12.3516 6.61328 12.2969 6.28516 12.2969C5.30078 12.2969 4.34375 12.7617 3.76953 13.582C3.44141 14.1016 3.25 14.7031 3.25 15.3594V16.5625C3.25 17.3008 3.82422 17.875 4.5625 17.875H12.4375C13.1484 17.875 13.75 17.3008 13.75 16.5625V15.3594C13.75 14.7031 13.5312 14.1016 13.2031 13.582C12.6289 12.7617 11.6719 12.2969 10.6875 12.2969ZM12.4375 16.5625H4.5625V15.3594C4.5625 14.5664 5.05469 13.8828 5.76562 13.6367C6.03906 13.5273 6.33984 13.5273 6.64062 13.6367C7.24219 13.8281 7.87109 13.9375 8.5 13.9375C9.12891 13.9375 9.73047 13.8281 10.3594 13.6367C10.6328 13.5273 10.9336 13.5273 11.2344 13.6367C11.918 13.8828 12.4375 14.5664 12.4375 15.3594V16.5625ZM8.5 11.75C10.168 11.75 11.5625 10.3828 11.5625 8.6875C11.5625 7.01953 10.168 5.625 8.5 5.625C6.80469 5.625 5.4375 7.01953 5.4375 8.6875C5.4375 10.3828 6.80469 11.75 8.5 11.75ZM8.5 6.9375C9.45703 6.9375 10.25 7.73047 10.25 8.6875C10.25 9.67188 9.45703 10.4375 8.5 10.4375C7.51562 10.4375 6.75 9.67188 6.75 8.6875C6.75 7.73047 7.51562 6.9375 8.5 6.9375ZM20.2852 13.4453C19.8203 12.7344 19.0273 12.3516 18.1797 12.3516C17.4414 12.3516 17.25 12.625 16.375 12.625C15.5 12.625 15.3086 12.3516 14.543 12.3516C14.1602 12.3516 13.832 12.4336 13.5039 12.5977C13.6406 12.7344 13.8047 12.9258 13.9414 13.0898C14.0508 13.2812 14.1602 13.5 14.2695 13.6914C14.3516 13.6914 14.4336 13.6641 14.543 13.6641C15.0078 13.6641 15.3359 13.9375 16.375 13.9375C17.3867 13.9375 17.7148 13.6641 18.1797 13.6641C18.6172 13.6641 19 13.8555 19.1914 14.1562C19.3555 14.375 19.4375 14.6211 19.4375 14.8945V15.6875H14.625V16.5625C14.625 16.7266 14.5977 16.8633 14.5703 17H19.6562C20.2578 17 20.75 16.5352 20.75 15.9062V14.8945C20.75 14.3477 20.5859 13.8555 20.2852 13.4453Z"
                fill="#989AA2"
              />
            </svg>

            <p class="JobCardV2-recruiterList">
              {#each recruiterList as recruiter, i}
                {`${recruiter.name}${
                  i + 1 !== recruiterList.length ? ', ' : ' '
                }`}
              {/each}
            </p>
          {:else}
            <button class="JobCardV2-assignRecruiter"
              ><svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.0625 10.125C15.4082 10.125 16.5 9.0332 16.5 7.6875C16.5 6.3418 15.4082 5.25 14.0625 5.25C12.7168 5.25 11.625 6.3418 11.625 7.6875C11.625 9.0332 12.7168 10.125 14.0625 10.125ZM14.0625 6.46875C14.7227 6.46875 15.2812 7.02734 15.2812 7.6875C15.2812 8.37305 14.7227 8.90625 14.0625 8.90625C13.377 8.90625 12.8438 8.37305 12.8438 7.6875C12.8438 7.02734 13.377 6.46875 14.0625 6.46875ZM8.78125 10.6328C8.47656 10.6328 8.17188 10.6836 7.86719 10.7852C7.51172 10.8867 7.13086 10.9375 6.72461 10.9375C6.34375 10.9375 5.96289 10.8867 5.60742 10.7852C5.30273 10.6836 4.99805 10.6328 4.69336 10.6328C3.7793 10.6328 2.89062 11.0645 2.35742 11.8262C2.05273 12.3086 1.875 12.8672 1.875 13.4766V14.5938C1.875 15.2793 2.4082 15.8125 3.09375 15.8125H10.4062C11.0664 15.8125 11.625 15.2793 11.625 14.5938V13.4766C11.625 12.8672 11.4219 12.3086 11.1172 11.8262C10.584 11.0645 9.69531 10.6328 8.78125 10.6328ZM10.4062 14.5938H3.09375V13.4766C3.09375 12.7402 3.55078 12.1055 4.21094 11.877C4.46484 11.7754 4.74414 11.7754 5.02344 11.877C5.58203 12.0547 6.16602 12.1562 6.75 12.1562C7.33398 12.1562 7.89258 12.0547 8.47656 11.877C8.73047 11.7754 9.00977 11.7754 9.28906 11.877C9.92383 12.1055 10.4062 12.7402 10.4062 13.4766V14.5938ZM6.75 10.125C8.29883 10.125 9.59375 8.85547 9.59375 7.28125C9.59375 5.73242 8.29883 4.4375 6.75 4.4375C5.17578 4.4375 3.90625 5.73242 3.90625 7.28125C3.90625 8.85547 5.17578 10.125 6.75 10.125ZM6.75 5.65625C7.63867 5.65625 8.375 6.39258 8.375 7.28125C8.375 8.19531 7.63867 8.90625 6.75 8.90625C5.83594 8.90625 5.125 8.19531 5.125 7.28125C5.125 6.39258 5.83594 5.65625 6.75 5.65625ZM17.6934 11.6992C17.2617 11.0391 16.5254 10.6836 15.7383 10.6836C15.0527 10.6836 14.875 10.9375 14.0625 10.9375C13.25 10.9375 13.0723 10.6836 12.3613 10.6836C12.0059 10.6836 11.7012 10.7598 11.3965 10.9121C11.5234 11.0391 11.6758 11.2168 11.8027 11.3691C11.9043 11.5469 12.0059 11.75 12.1074 11.9277C12.1836 11.9277 12.2598 11.9023 12.3613 11.9023C12.793 11.9023 13.0977 12.1562 14.0625 12.1562C15.002 12.1562 15.3066 11.9023 15.7383 11.9023C16.1445 11.9023 16.5 12.0801 16.6777 12.3594C16.8301 12.5625 16.9062 12.791 16.9062 13.0449V13.7812H12.4375V14.5938C12.4375 14.7461 12.4121 14.873 12.3867 15H17.1094C17.668 15 18.125 14.5684 18.125 13.9844V13.0449C18.125 12.5371 17.9727 12.0801 17.6934 11.6992Z"
                  fill="#262626"
                />
              </svg>

              Assign Recruiter</button
            >
          {/if}
        </div>
      {/if}
      <div class="JobCardV2-tab-actions">
        <span
          on:click={() => {
            activeTab = 'list_view';
            activeTab = activeTab;
          }}
          ><svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.33334 10C8.77084 10 8.33334 9.5625 8.33334 9C8.33334 8.46875 8.77084 8 9.33334 8C9.86459 8 10.3333 8.46875 10.3333 9C10.3333 9.5625 9.86459 10 9.33334 10ZM11.5833 9C11.5833 8.59375 11.8958 8.25 12.3333 8.25H15.3333C15.7396 8.25 16.0833 8.59375 16.0833 9C16.0833 9.4375 15.7396 9.75 15.3333 9.75H12.3333C11.8958 9.75 11.5833 9.4375 11.5833 9ZM11.5833 12C11.5833 11.5938 11.8958 11.25 12.3333 11.25H15.3333C15.7396 11.25 16.0833 11.5938 16.0833 12C16.0833 12.4375 15.7396 12.75 15.3333 12.75H12.3333C11.8958 12.75 11.5833 12.4375 11.5833 12ZM11.5833 15C11.5833 14.5938 11.8958 14.25 12.3333 14.25H15.3333C15.7396 14.25 16.0833 14.5938 16.0833 15C16.0833 15.4375 15.7396 15.75 15.3333 15.75H12.3333C11.8958 15.75 11.5833 15.4375 11.5833 15ZM9.33334 11C9.86459 11 10.3333 11.4688 10.3333 12C10.3333 12.5625 9.86459 13 9.33334 13C8.77084 13 8.33334 12.5625 8.33334 12C8.33334 11.4688 8.77084 11 9.33334 11ZM9.33334 16C8.77084 16 8.33334 15.5625 8.33334 15C8.33334 14.4688 8.77084 14 9.33334 14C9.86459 14 10.3333 14.4688 10.3333 15C10.3333 15.5625 9.86459 16 9.33334 16ZM5.33334 7C5.33334 5.90625 6.20834 5 7.33334 5H17.3333C18.4271 5 19.3333 5.90625 19.3333 7V17C19.3333 18.125 18.4271 19 17.3333 19H7.33334C6.20834 19 5.33334 18.125 5.33334 17V7ZM6.83334 7V17C6.83334 17.2812 7.05209 17.5 7.33334 17.5H17.3333C17.5833 17.5 17.8333 17.2812 17.8333 17V7C17.8333 6.75 17.5833 6.5 17.3333 6.5H7.33334C7.05209 6.5 6.83334 6.75 6.83334 7Z"
              fill={activeTab === 'list_view' ? '#2E5FF6' : '#989AA2'}
            />
          </svg>
        </span>
        <span
          on:click={() => {
            activeTab = 'map_view';
            activeTab = activeTab;
          }}
          ><svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.8333 10C14.8333 11.4062 13.7083 12.5 12.3333 12.5C10.9271 12.5 9.83334 11.4062 9.83334 10C9.83334 8.625 10.9271 7.5 12.3333 7.5C13.7083 7.5 14.8333 8.625 14.8333 10ZM12.3333 9C11.7708 9 11.3333 9.46875 11.3333 10C11.3333 10.5625 11.7708 11 12.3333 11C12.8646 11 13.3333 10.5625 13.3333 10C13.3333 9.46875 12.8646 9 12.3333 9ZM18.3333 10C18.3333 12.75 14.6771 17.5938 13.0521 19.625C12.6771 20.0938 11.9583 20.0938 11.5833 19.625C9.95834 17.5938 6.33334 12.75 6.33334 10C6.33334 6.6875 8.98959 4 12.3333 4C15.6458 4 18.3333 6.6875 18.3333 10ZM12.3333 5.5C9.83334 5.5 7.83334 7.53125 7.83334 10C7.83334 10.4062 7.95834 11 8.30209 11.8125C8.61459 12.5625 9.08334 13.4375 9.61459 14.3125C10.5208 15.75 11.5521 17.125 12.3333 18.125C13.0833 17.125 14.1146 15.75 15.0208 14.3125C15.5521 13.4375 16.0208 12.5625 16.3333 11.8125C16.6771 11 16.8333 10.4062 16.8333 10C16.8333 7.53125 14.8021 5.5 12.3333 5.5Z"
              fill={activeTab === 'map_view' ? '#2E5FF6' : '#989AA2'}
            />
          </svg>
        </span>
      </div>
    </div>

    {#if activeTab === 'list_view'}
      <cdlc-job-card-v2-detail-list
        job={loadedJob || shuffledJob}
        settings={mergedSettings}
        on:viewMap={() => {
          activeTab = 'map_view';
          activeTab = activeTab;
        }}
        on:viewBenefits={() => {
          dispatch('viewBenefits');
        }}
      />
    {:else}
      <cdlc-job-card-v2-map job={loadedJob || shuffledJob} />
    {/if}

    <div class="JobCardV2-bottomActions">
      {#if mergedSettings.mainBottomBtns && mergedSettings.mainBottomBtns.length}
        {#each mergedSettings.mainBottomBtns as mainBtn}
          <button
            class={mainBtn.class}
            style={mainBtn.style}
            on:click={() => {
              dispatch(mainBtn.handler);
            }}>{@html mainBtn.title}</button
          >
        {/each}
      {/if}
    </div>
  </div>
{/if}

<style src="./JobCardV2.scss">
</style>
